import { kDefaultFaviconPath } from '@/constants/constants-ui'

export default function AppIcon() {
  return (
    <div className="flex h-[60px] w-[60px] shrink-0 items-center justify-center rounded-md border border-brand-neutral-200 bg-[linear-gradient(47deg,#fff6de_0%,#fcf7e7_21%,#fff_53%,#e3f2fd_82%,#a1d2f7_106%)]">
      <img src={kDefaultFaviconPath} alt="" className="max-h-8 max-w-8" />
    </div>
  )
}
